/* tslint:disable */
/* eslint-disable */
/**
 * Oasisscan API
 * https://github.com/bitcat365/oasisscan-backend#readme https://api.oasisscan.com/mainnet/swagger-ui/#/ https://api.oasisscan.com/mainnet/v2/api-docs 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperationsEntity
 */
export interface OperationsEntity {
    /**
     * 
     * @type {string}
     * @memberof OperationsEntity
     */
    txHash: string;
    /**
     * 
     * @type {number}
     * @memberof OperationsEntity
     */
    height: number;
    /**
     * 
     * @type {string}
     * @memberof OperationsEntity
     */
    method: OperationsEntityMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof OperationsEntity
     */
    fee: string;
    /**
     * 
     * @type {string}
     * @memberof OperationsEntity
     */
    amount: string | null;
    /**
     * 
     * @type {string}
     * @memberof OperationsEntity
     */
    shares?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OperationsEntity
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof OperationsEntity
     */
    time: number;
    /**
     * 
     * @type {boolean}
     * @memberof OperationsEntity
     */
    status: boolean;
    /**
     * 
     * @type {string}
     * @memberof OperationsEntity
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof OperationsEntity
     */
    to: string | null;
    /**
     * 
     * @type {string}
     * @memberof OperationsEntity
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OperationsEntity
     */
    nonce: number;
}

/**
* @export
* @enum {string}
*/
export enum OperationsEntityMethodEnum {
    StakingTransfer = 'staking.Transfer',
    StakingAddEscrow = 'staking.AddEscrow',
    StakingReclaimEscrow = 'staking.ReclaimEscrow',
    StakingAmendCommissionSchedule = 'staking.AmendCommissionSchedule',
    StakingAllow = 'staking.Allow',
    StakingWithdraw = 'staking.Withdraw',
    StakingBurn = 'staking.Burn',
    RoothashExecutorCommit = 'roothash.ExecutorCommit',
    RoothashExecutorProposerTimeout = 'roothash.ExecutorProposerTimeout',
    RoothashSubmitMsg = 'roothash.SubmitMsg',
    RegistryDeregisterEntity = 'registry.DeregisterEntity',
    RegistryRegisterEntity = 'registry.RegisterEntity',
    RegistryRegisterNode = 'registry.RegisterNode',
    RegistryRegisterRuntime = 'registry.RegisterRuntime',
    RegistryUnfreezeNode = 'registry.UnfreezeNode',
    GovernanceCastVote = 'governance.CastVote',
    GovernanceSubmitProposal = 'governance.SubmitProposal',
    BeaconPvssCommit = 'beacon.PVSSCommit',
    BeaconPvssReveal = 'beacon.PVSSReveal',
    BeaconVrfProve = 'beacon.VRFProve',
    ConsensusMeta = 'consensus.Meta'
}

export function OperationsEntityFromJSON(json: any): OperationsEntity {
    return OperationsEntityFromJSONTyped(json, false);
}

export function OperationsEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationsEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'txHash': json['txHash'],
        'height': json['height'],
        'method': json['method'],
        'fee': json['fee'],
        'amount': json['amount'],
        'shares': !exists(json, 'shares') ? undefined : json['shares'],
        'timestamp': json['timestamp'],
        'time': json['time'],
        'status': json['status'],
        'from': json['from'],
        'to': json['to'],
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'nonce': json['nonce'],
    };
}

export function OperationsEntityToJSON(value?: OperationsEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'txHash': value.txHash,
        'height': value.height,
        'method': value.method,
        'fee': value.fee,
        'amount': value.amount,
        'shares': value.shares,
        'timestamp': value.timestamp,
        'time': value.time,
        'status': value.status,
        'from': value.from,
        'to': value.to,
        'errorMessage': value.errorMessage,
        'nonce': value.nonce,
    };
}


